/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * PaymentSheetResponseBase
 * auto generated base class for the model PaymentSheetResponseModel.
 */
export const PaymentSheetResponseModelBase = ModelBase.named('PaymentSheetResponse')
  .props({
    __typename: types.optional(types.literal('PaymentSheetResponse'), 'PaymentSheetResponse'),
    customer: types.union(types.undefined, types.string),
    ephemeralKey: types.union(types.undefined, types.string),
    paymentIntent: types.union(types.undefined, types.string),
    publishableKey: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PaymentSheetResponseModelSelector extends QueryBuilder {
  get customer() {
    return this.__attr('customer')
  }
  get ephemeralKey() {
    return this.__attr('ephemeralKey')
  }
  get paymentIntent() {
    return this.__attr('paymentIntent')
  }
  get publishableKey() {
    return this.__attr('publishableKey')
  }
}
export function selectFromPaymentSheetResponse() {
  return new PaymentSheetResponseModelSelector()
}

export const paymentSheetResponseModelPrimitives =
  selectFromPaymentSheetResponse().customer.ephemeralKey.paymentIntent.publishableKey
